;(function (angular, moment, _) {
  'use strict'

  angular
    .module('kilo.routes.quote.show', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = [ '$stateProvider' ]

  function RouteConfigurator ($stateProvider) {
    const baseState = {
      // Retire le watcher $rootScope de la pagination résolue à la sortie de l'état
      // (baseState est recopié dans chaque état : chacun résout et détruit la sienne)
      onExit: ['creditNotePagination', function (creditNotePagination) { creditNotePagination.destroy() }],
      resolve: {
        fromQuote () {},
        fromToDeposit () {},
        creditNotePagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp-creditNoteList', { perPage: 5 })
        }],
        template: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getQuotePrefs().then(function (prefs) {
            return prefs.numberFormat
          })
        }],
        initParams: ['$stateParams', function ($stateParams) {
          return $stateParams.initParams
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(
            CustomFieldManager
              .query()
              .select('quote', 'model')).then(function (data) {
            return data.data
          })
        }],
        vats: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats
          })
        }],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs()
        }],
        model: [() => {
          return 'quote'
        }]
      },
      params: {
        initParams: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/quote/show/templates/quote-show.template.html',
          controller: 'ElementShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/quote/show/templates/quote-show-toolbar.html',
          controller: 'QuoteShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: "{{::toolbar.status === 'draft' ? toolbar.title : toolbar.number | truncate: 50}}" + '{{toolbar.status === \'draft\' && !toolbar.quote.isModel ? \' (Brouillon)\' : \'\'}}' + '{{toolbar.quote.isModel ? \' (Modèle de devis pré-rempli)\' : \'\'}}',
        parent: 'quote.list'
      }
    }

    var showState = {
      ...baseState,
      name: 'quote.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        ...baseState.resolve,
        element: [ '$stateParams', 'QuoteManager', function ($stateParams, QuoteManager) {
          return QuoteManager.findById($stateParams.id, QuoteManager.query({
            populate: JSON.stringify([
              { path: 'client' },
              { path: 'delivery' },
              { path: 'tags' },
              { path: 'referers' },
              { path: 'invoiceDeposit' },
              { path: 'bpu', populate: [{ path: 'client' }] },
              { path: 'lines.subcontracts.entity' },
              { path: 'lines.product.productType' },
              { path: 'lines.productType' },
              { path: 'facturXAttachments' },
              { path: 'linkedData.solica.interventions',
                populate: [
                  {
                    path: 'linkedData.lifo.stockOut.stock',
                    // WE NEED TO GO DEEPER
                    populate: [{ path: 'product' }]
                  }
                ]
              }
            ])
          })
          )
        }]
      }
    }

    var newState = {
      ...baseState,
      name: 'quote.new',
      url: '/new',
      resolve: {
        ...baseState.resolve,
        element: ['QuoteService', function (QuoteService) {
          return QuoteService.createQuoteFromPreferences()
        }]
      },
      ncyBreadcrumb: {
        ...baseState.ncyBreadcrumb,
        label: "Création d'un devis"
      }
    }

    var showTemplate = {
      ...baseState,
      resolve: {
        fromQuote: function () {},
        fromToDeposit: function () {},
        ...baseState.resolve,
        element: ['$stateParams', 'QuoteManager', function ($stateParams, QuoteManager) {
          return QuoteManager.findById($stateParams.id, QuoteManager.query({
            populate: JSON.stringify([
              { path: 'client' },
              { path: 'delivery' },
              { path: 'tags' },
              { path: 'referers' },
              { path: 'bpu', populate: [{ path: 'client' }] },
              { path: 'lines.subcontracts.entity' },
              { path: 'lines.product.productType' },
              { path: 'lines.productType' }
            ])
          })
          )
        }]
      },
      name: 'quote.showTemplate',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}'
    }

    var newTemplate = {
      ...baseState,
      name: 'quote.newTemplate',
      url: '/newTemplate',
      resolve: {
        ...baseState.resolve,
        element: ['QuoteManager',
          function (QuoteManager) {
            return QuoteManager.create({
              status: 'draft',
              isModel: true
            }
            )
          }],
        fromQuote: function () {},
        fromToDeposit: function () {}
      },
      ncyBreadcrumb: {
        ...baseState.ncyBreadcrumb,
        label: 'Création d\'un modèle de devis pré-rempli'
      }
    }

    $stateProvider
      .state(showState)
      .state(newState)
      .state(showTemplate)
      .state(newTemplate)
  }
})(window.angular, window.moment, window._)
